<div class="d-flex align-items-center">
    <button mat-flat-button class="custom-button-volver" (click)="goBack()">
        <mat-icon aria-hidden="false" aria-label="Volver" fontIcon="arrow_back" class="icon-volver mr-3"></mat-icon>
        Volver
    </button>
</div>
<div class="container-fluid bg-white p-5 mb-5 br-10">
    <h1>Procesos ejecutados</h1>

    <div class="d-flex flex-row">

        <mat-chip-set class="mr-3">
            <mat-chip class="chip-info br-5">
                <strong>ID:</strong> {{ detail?.id }}
            </mat-chip>
        </mat-chip-set>

        <mat-chip-set>
            <mat-chip class="chip-info br-5">
                <strong>Nombre:</strong> {{ detail?.name }}
            </mat-chip>
        </mat-chip-set>

    </div>

    <mat-card class="simple-card mx-auto my-5">
        <mat-card-header>
            <mat-card-title class="font-size-title-card">
                <mat-chip class="chip-info mr-2"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                <strong>Filtros</strong>
            </mat-card-title>
        </mat-card-header>

        <mat-card-content class="p-5">

            <div [formGroup]="filtersForm" class="three-equal-columns-grid">
                <mat-form-field appearance="outline">
                    <mat-label>Modelo</mat-label>
                    <mat-select formControlName="batchTemplateTag">
                        <mat-option *ngFor="let model of modelos" [value]="model.batchTemplate?.tag">
                            {{ model.batchTemplate?.tag }}
                        </mat-option>
                    </mat-select>
                    <div matSuffix class="mr-3">
                        <mat-spinner *ngIf="isModelosListLoading" [diameter]="18"></mat-spinner>
                    </div>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label class="text-overflow-ellipsis">Fecha Inicio</mat-label>
                    <input
                        matInput
                        [matDatepicker]="dateFromPicker"
                        class="mat-datepicker-input"
                        formControlName="dateFrom">
                    <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateFromPicker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label class="text-overflow-ellipsis">Fecha Fin</mat-label>
                    <input
                        matInput
                        [matDatepicker]="dateToPicker"
                        class="mat-datepicker-input"
                        formControlName="dateTo">
                    <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateToPicker></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="d-flex justify-content-end">
                <button mat-flat-button class="custom-button-primary" type="button" [disabled]="filtersForm.invalid" (click)="searchProcesses()">
                    <mat-icon class="mr-3">search</mat-icon>
                    Buscar
                </button>
            </div>

        </mat-card-content>


    </mat-card>

    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="fechaEjecucion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por fecha de ejecución">Fecha de ejecución</th>
                <td mat-cell *matCellDef="let element">{{ element?.creationDate | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por ID">ID proceso</th>
                <td mat-cell *matCellDef="let element">{{ element?.id }}</td>
            </ng-container>

            <ng-container matColumnDef="modelo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por modelo">Modelo</th>
                <td mat-cell *matCellDef="let element">{{ element?.batchTemplate?.name ? element?.batchTemplate?.name : element?.batchTemplate?.tag }}</td>
            </ng-container>

            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por estado">Estado</th>
                <td mat-cell *matCellDef="let element">{{ element?.status }}</td>
            </ng-container>

            <ng-container matColumnDef="frecuencia">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por frecuencia">Frecuencia</th>
                <td mat-cell *matCellDef="let element">{{ element?.frequency?.description ? element?.frequency?.description : element?.frequency?.name }}</td>
            </ng-container>

            <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear sortActionDescription="Ordenado por acciones">Acciones</th>
                <td mat-cell *matCellDef="let element">
                    <button
                        mat-flat-button
                        class="custom-button-secondary"
                        type="button"
                        (click)="viewExecDetail(element.id, element.batchConfigId)">
                        Ver detalle
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="progress">
                <th mat-cell *matCellDef="let element"></th>
                <td mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                    <mat-progress-bar *ngIf="isProcessesListLoading" mode="indeterminate"></mat-progress-bar>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-header-row *matHeaderRowDef="['progress']; sticky: true" class="progress-row"></tr>

            <ng-container *ngIf="!isProcessesListLoading">
                <tr class="mat-mdc-row" *matNoDataRow>
                    <td class="mat-mdc-cell text-center font-weight-500 loading-cell" [attr.colspan]="displayedColumns.length">
                        No hay datos disponibles
                    </td>
                </tr>
            </ng-container>
        </table>
    </div>

    <mat-paginator
        [pageSizeOptions]="[10, 20, 50, 100]"
        showFirstLastButtons
        aria-label="Seleccionar página">
    </mat-paginator>
</div>